import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getDashboardItemData(
    {
        dashboardID,
        itemID,
        filterItem,
        filterValue,
        parameters,
        limit,
        locale,
        overrideParameters,
        overrideGroup,
        overrideFilter,
        overrideOptions,
        overrideType,
        globalFilter,
    },
    signal,
    {ClientID, LocalUserID} = {}
) {
    const {_LocalUserID, _ClientID} = getUserApiData({ClientID, LocalUserID});
    return invokeApig({
        ...Paths.getDashboardItemData({
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: {
            dashboardID,
            itemID,
            filterItem,
            filterValue,
            parameters,
            limit,
            locale,
            overrideParameters,
            overrideGroup,
            overrideFilter,
            overrideOptions,
            overrideType,
            globalFilter,
        },
        signal,
    });
}
